import { useQuery } from '@apollo/client'
import { getThread as getThreadGql } from 'src/graphql/queries/getThread.gql'

const useThread = (variables, options = {}) => {
   const { data, error, networkStatus, refetch, loading } = useQuery(getThreadGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...options
   })

   return {
      thread: data?.thread,
      error,
      loading,
      networkStatus,
      refetch
   }
}

export default useThread
